//
// JS entry point
// ================================================================================

import { menu } from './menu.js';
import { quotes } from './quotes.js';
// import { revealAnimations } from './reveal-animations'; // Replaced by GSAP
import { scrollPosition } from './scroll-position';
import { initVideoPlayers } from './video.js';
import { initArrowScroll } from './arrow-scroll.js';
import { initDetailsLayout } from './details-layout.js';
import { initAnalytics } from './analytics.js';
import { initGSAP } from './gsap-init.js';
import { initGSAPModules } from './gsap/index.js';
import { initSorteoComponent } from './sorteo.js';
import { initTicketingComponent } from './ticketing.js';
import { initHorizontalScroll, destroyHorizontalScroll } from './gsap/horizontal-scroll.js';


/** Vista estrecha: mismo criterio que breakpoint lg (1024px): scroll de documento vertical, no “carril” horizontal. */
function isNarrowScrollViewport() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 1023px)').matches;
}

/**
 * El servidor siempre pone horizontal-scroll-active si el JSON es horizontal-snap.
 * En móvil/tablet eso dejaba body a 100vh + main en fila: el scroll vertical del documento se engancha.
 * Desmontamos pin, ScrollTrigger horizontal, clases y globals como en desktop “solo vertical”.
 */
function teardownHorizontalLayoutForNarrowViewports() {
    const body = document.body;
    if (!body || !isNarrowScrollViewport() || !body.classList.contains('horizontal-scroll-active')) {
        return;
    }

    destroyHorizontalScroll();

    body.classList.remove('horizontal-scroll-active');
    body.classList.remove('hero-logo-not-loaded');
    body.removeAttribute('data-scroll-mode');

    body.style.overflowY = '';
    body.style.height = '';
    const html = document.documentElement;
    if (html) {
        html.style.overflowY = '';
        html.style.height = '';
        html.classList.remove('horizontal-smooth-mode');
    }

    const main = document.querySelector('.c-main');
    if (main) main.classList.remove('horizontal-scroll-wrapper');

    const pinWrapper = document.getElementById('horizontal-scroll-pin-wrapper');
    if (pinWrapper && pinWrapper.parentNode === body) {
        while (pinWrapper.firstChild) body.insertBefore(pinWrapper.firstChild, pinWrapper);
        body.removeChild(pinWrapper);
    }

    document.querySelectorAll('.horizontal-scroll-next-arrow, .horizontal-scroll-prev-arrow').forEach(el => el.remove());

    try {
        delete window.__horizontalScrollSections;
        delete window.__horizontalScrollNonParallaxSections;
        delete window.__scrollToSectionIndex;
        delete window.__currentSectionIndex;
    } catch (_e) {
        // ignore
    }
}



function autorun(){
    const body = document.body;

    teardownHorizontalLayoutForNarrowViewports();

    if (typeof window.matchMedia === 'function') {
        window.matchMedia('(max-width: 1023px)').addEventListener('change', () => {
            teardownHorizontalLayoutForNarrowViewports();
        });
    }

    // Ocultar botones del navbar en desktop hasta que cargue el logo del hero (clase + regla inyectada)
    const isDesktop = body && window.matchMedia('(min-width: 1024px)').matches;
    const isHorizontal = body && body.classList.contains('horizontal-scroll-active');
    if (body && isHorizontal && isDesktop) {
        body.classList.add('hero-logo-not-loaded');
        const style = document.createElement('style');
        style.id = 'hero-logo-nav-hide';
        style.textContent = '@media (min-width:1024px){body.hero-logo-not-loaded .c-menu__nav .c-menu__anchor{visibility:hidden!important;opacity:0!important}}';
        (document.head || document.documentElement).appendChild(style);
    }

    // Prevent parallax.js library from initializing in horizontal mode
    if (body && body.classList.contains('horizontal-scroll-active')) {
        // Remove data-parallax attributes to prevent external library from initializing
        document.querySelectorAll('[data-parallax]').forEach(el => {
            el.removeAttribute('data-parallax');
        });
    }
    
    // Initialize GSAP first
    initGSAP();
    
    // Check if horizontal scroll mode is active (disabled on narrow viewports; see teardown above)
    const isHorizontalActive = body && body.classList.contains('horizontal-scroll-active');
    
    if (isHorizontalActive) {
        // Determine mode from data attribute on body or HTML structure
        const main = document.querySelector('.c-main');
        const bodyDataMode = body.getAttribute('data-scroll-mode');
        // For horizontal-snap, we should not have smooth-wrapper
        const hasSmoothWrapper = document.querySelector('#smooth-wrapper');
        
        // Force snap mode if data.json says horizontal-snap (even if HTML has old structure)
        // If bodyDataMode is null, check if smooth-wrapper exists to determine mode
        let mode;
        if (bodyDataMode === 'horizontal-snap') {
            mode = 'horizontal-snap'; // Force snap mode
            // Remove smooth-wrapper if it exists (old HTML structure)
            if (hasSmoothWrapper) {
                const wrapper = hasSmoothWrapper;
                const parent = wrapper.parentNode;
                while (wrapper.firstChild) {
                    parent.insertBefore(wrapper.firstChild, wrapper);
                }
                parent.removeChild(wrapper);
            }
        } else if (bodyDataMode === 'horizontal') {
            mode = 'horizontal';
        } else {
            // Fallback: use HTML structure to determine mode
            mode = hasSmoothWrapper ? 'horizontal' : 'horizontal-snap';
        }
        
        // Initialize horizontal scroll (should be initialized before other modules)
        initHorizontalScroll(mode);
    }
    
    // Initialize menu functionality
    menu();
    
    // Initialize GSAP modules based on variants
    initGSAPModules();
    
    // Other functionality
    // revealAnimations(); // Replaced by GSAP - commented out but kept for reference
    scrollPosition();
    initVideoPlayers();
    initArrowScroll();
    initDetailsLayout();
    initAnalytics();
    initSorteoComponent();
    initTicketingComponent();
    
   
    console.log('Scripts Loaded!');
};

if (document.addEventListener) document.addEventListener("DOMContentLoaded", autorun, false);
else if (document.attachEvent) document.attachEvent("onreadystatechange", autorun);
else window.onload = autorun;
